export default __webpack_public_path__ + "static/media/LuLu-Compressed.59ed3270.png";